import { render, staticRenderFns } from "./MenuConfigurationSchemaField.vue?vue&type=template&id=5cdd2db5"
import script from "./MenuConfigurationSchemaField.vue?vue&type=script&lang=js"
export * from "./MenuConfigurationSchemaField.vue?vue&type=script&lang=js"
import style0 from "./MenuConfigurationSchemaField.vue?vue&type=style&index=0&id=5cdd2db5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports